import { useCallback, useEffect, useState } from "react";

export const OTP_COUNTDOWN_SECONDS = 60;

export function formatCountdown(seconds: number): string {
  const valid = Number.isFinite(seconds) && seconds >= 0 ? seconds : 0;
  const m = Math.floor(valid / 60);
  const s = valid % 60;
  return `${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
}

export type CountdownState = ReturnType<typeof useCountdown>;

export function useCountdown(initialSeconds = 0) {
  const [countdown, setCountdown] = useState(initialSeconds);

  useEffect(() => {
    if (countdown <= 0) return;
    const timer = setInterval(() => {
      setCountdown((prev) => (prev <= 1 ? 0 : prev - 1));
    }, 1000);
    return () => clearInterval(timer);
  }, [countdown]);

  const reset = useCallback((seconds = OTP_COUNTDOWN_SECONDS) => {
    setCountdown(seconds);
  }, []);

  return {
    countdown,
    isActive: countdown > 0,
    formatted: formatCountdown(countdown),
    reset,
  };
}
